import { render, staticRenderFns } from "./ReviewProgress.vue?vue&type=template&id=e20ae412&scoped=true&"
import script from "./ReviewProgress.vue?vue&type=script&lang=js&"
export * from "./ReviewProgress.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProgress.vue?vue&type=style&index=0&id=e20ae412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ae412",
  null
  
)

export default component.exports